import cookies from 'js-cookie';
import yousersjs from '@yola/yousersjs';
import Configuration from '../modules/configuration';
import User from '../modules/user';

const setUserLocale = (locale) => {
  const config = Configuration.get();
  const user = User.get();
  const domain = config.getDomainForLocaleCookie();
  const localeCookieName = config.getLocaleCookieName();

  if (user.isAuthenticated()) {
    yousersjs.preferences().update({ locale });
  }

  cookies.set(localeCookieName, locale, { domain });
};

export default setUserLocale;
